import { useQuery } from '@tanstack/react-query';

import type {
  PredefinedMessage,
  PredefinedMessageApiResponse,
  PredefinedMessageFormValues,
} from '@/types/predefined-messages';

import httpClient from '@/lib/axios-instance';
import { normalizeRoleCodeArray } from '@/lib/helpers/role-mapper';
import { API_ROUTES } from '@/lib/routes/api-routes';

export const PREDEFINED_MESSAGES_QUERY_KEY = ['predefinedMessages'] as const;

export function mapPredefinedMessage({
  id,
  message,
  predefinedMessageCategoryId,
  category,
  availableTo,
  recipients,
  prioritized,
}: PredefinedMessageApiResponse): PredefinedMessage {
  return {
    id,
    message,
    predefinedMessageCategoryId: predefinedMessageCategoryId ?? category?.id ?? 0,
    availableToIds: normalizeRoleCodeArray(availableTo ?? []),
    recipientIds: normalizeRoleCodeArray(recipients ?? []),
    prioritized: prioritized ?? false,
  };
}

export function mapPredefinedMessageFormValuesToApiPayload({
  message,
  predefinedMessageCategoryId,
  availableToIds,
  recipientIds,
  prioritized,
}: PredefinedMessageFormValues) {
  return {
    message: message,
    predefined_message_category_id: predefinedMessageCategoryId,
    available_to: availableToIds,
    recipients: recipientIds,
    prioritized,
  };
}

export function usePredefinedMessageQueries() {
  return useQuery({
    queryKey: PREDEFINED_MESSAGES_QUERY_KEY,
    queryFn: async () => {
      const { data } = await httpClient.get<PredefinedMessageApiResponse[]>(
        API_ROUTES.predefinedMessages.list
      );

      return data.map(mapPredefinedMessage);
    },
  });
}
